var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCamera = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 9.6,
    viewBox: "0 0 16 9.6",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.2 1.6a1.6 1.6 0 0 0-1.6 1.6v3.2A1.6 1.6 0 0 0 3.2 8H8a1.6 1.6 0 0 0 1.6-1.6V3.2A1.6 1.6 0 0 0 8 1.6zm7.984 1.284L12.8 1.268A1.6 1.6 0 0 1 13.931.8h.469A1.6 1.6 0 0 1 16 2.4v4.8a1.6 1.6 0 0 1-1.6 1.6h-.469a1.6 1.6 0 0 1-1.131-.469l-1.616-1.615A3.2 3.2 0 0 1 8 9.6H3.2A3.2 3.2 0 0 1 0 6.4V3.2A3.2 3.2 0 0 1 3.2 0H8a3.2 3.2 0 0 1 3.184 2.884zM13.932 7.2h.468V2.4h-.469l-2.4 2.4 2.4 2.4zM4 6.4a.8.8 0 1 1 .8-.8.8.8 0 0 1-.8.8z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCamera);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/camera.c32443fdce23614142e5f289361f551c.svg";